// useApiKeys — TanStack Query hook for the current merchant's API keys.
//
// Mirrors the useBankAccounts() pattern: selects status from useAuth and
// currentMerchantId from useUI; guards the query on both. queryKey is
// per-merchant so the cache is scoped correctly when the user switches
// merchants.
import { useQuery } from "@tanstack/react-query";

import { listApiKeys } from "@/api/apiKeys";
import { useAuth } from "@/store/auth";
import { useUI } from "@/store/ui";

export function useApiKeys() {
  const status = useAuth((s) => s.status);
  const currentMerchantId = useUI((s) => s.currentMerchantId);

  return useQuery({
    queryKey: ["api-keys", currentMerchantId],
    queryFn: () => listApiKeys(currentMerchantId!),
    enabled: status === "authenticated" && currentMerchantId != null,
    staleTime: 30_000,
  });
}
